import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetQuiz } from 'redux/reducers/quiz'
import validateStageOnboarding from 'utils/validateStage'
import { CircularProgress } from '@mui/material'
import { roles } from 'utils/constants/roles'

import { FailContainer } from './styles'

export default (props) => {
  const { history } = props
  
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  const { token } = useSelector((state) => state.token)

  const handleLoading = (newState) => {
    setLoading(newState)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.QUIZ, handleLoading)
    dispatch(resetQuiz())
  }, [])

  return loading ? (
    <div className="loading">
      <div
        className="loading__container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <CircularProgress style={{ textAlign: 'center' }} />
      </div>
    </div>
  ) : (
    <FailContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h1>Não é possível prosseguir</h1>
      <h4>O máximo de tentativas foi atingido.</h4>
      <br />
      <h4>
        Entre em contato através de um de nossos atendimentos para mais
        informações.
      </h4>
    </FailContainer>
  )
}
